import { ApplicationTypes, attachComponent } from 'awr-domain'

import { memoEval, propertyPageComponent, sceneEntityObjectComponent } from '@salsita-ai/platform-project-sdk/domain'
import { AttributeSwitchSelector } from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

import { createDeckSectionObject, createDeckSectionSketchingObject } from '../canvas/deck-section.js'

export const deckSectionComponents = [
  attachComponent
    .withEntity('DeckSection')
    .withComponent(sceneEntityObjectComponent, 'main')
    .withGradualFilter({ viewStates: [ApplicationTypes.ViewState['3dView']] })
    .attach(
      memoEval(
        (s, state, ctx) => {
          const shape = ctx.sketchingProjections.getEntityLine(s.id, state, 'main')

          return [shape.length, shape.start.connection?.angle ?? 0, shape.end.connection?.angle ?? 0]
        },
        (length, leftAngle, rightAngle) => {
          return { object: createDeckSectionObject({ length, leftAngle, rightAngle }) }
        }
      )
    ),
  attachComponent
    .withEntity('DeckSection')
    .withComponent(sceneEntityObjectComponent, 'mainFloorPlan')
    .withGradualFilter({
      viewStates: [ApplicationTypes.ViewState.FloorPlan],
      navigationStates: [ApplicationTypes.NavigationState.Properties, ApplicationTypes.NavigationState.Summary],
    })
    .attach(
      memoEval(
        (s, state, ctx) => {
          const shape = ctx.sketchingProjections.getEntityLine(s.id, state, 'main')

          return [shape.length, shape.start.connection?.angle ?? 0, shape.end.connection?.angle ?? 0]
        },
        (length, leftAngle, rightAngle) => {
          return { object: createDeckSectionObject({ length, leftAngle, rightAngle }) }
        }
      )
    ),
  attachComponent
    .withEntity('DeckSection')
    .withComponent(sceneEntityObjectComponent, 'sketching')
    .withGradualFilter({
      viewStates: [ApplicationTypes.ViewState.FloorPlan],
      navigationStates: [ApplicationTypes.NavigationState.Build],
    })
    .attach(
      memoEval(
        s => [s.length, s.balustrade],
        (length, balustrade) => {
          return { object: createDeckSectionSketchingObject({ length, balustrade }) }
        }
      )
    ),

  attachComponent
    .withEntity('DeckSection')
    .withComponent(propertyPageComponent, 'main')
    .attach(
      memoEval(
        s => [s.id],
        id => ({
          page: (
            <>
              <PropertyContainer.Group spacing="large">
                <PropertyContainer.Item>
                  <AttributeSwitchSelector entityId={id} instanceName="balustrade" title="Balustrade" description="" />
                </PropertyContainer.Item>
              </PropertyContainer.Group>
            </>
          ),
        })
      )
    ),
]
